<template>
	<span class="gyl-sort">
    <Icon class="sort-arrow" type="ios-arrow-up" @click="sort('up',sortKey)"></Icon>
    <Icon class="sort-arrow" type="ios-arrow-down" @click="sort('down',sortKey)"></Icon>
  </span>
</template>
<script>
export default {
	name: 'gyl-sort',
  props: {
    sortKey: {
			type: String,
			default:''
		},
  },
	data () {
		return {
      
		}
	},
  created() {
  },
	methods: {
    sort(type,sortKey) {
      this.$emit('sort',{type, sortKey})
    }
	}
}
</script>
<style scoped>
.gyl-sort{display:inline-block;width:18px;height:18px;margin-left:4px;margin-top:-1px;vertical-align:middle;overflow:hidden;cursor:pointer;position:relative}
.gyl-sort .sort-arrow{display:block;height:6px;line-height:6px;overflow:hidden;position:absolute;color:#c5c8ce;-webkit-transition:color .2s ease-in-out;transition:color .2s ease-in-out;font-size:16px}
.gyl-sort .sort-arrow:hover{color:inherit}.gyl-sort .sort-arrow.on{color:#2d8cf0}.gyl-sort .sort-arrow:first-child{top:0}.gyl-sort .sort-arrow:last-child{bottom:0}
  </style>


// WEBPACK FOOTER //
// src/components/inc/component/gyl-sort.vue